;(function () {
  'use strict'

  angular
    .module('contrast.filtering')
    .factory('AdvancedFiltersService', AdvancedFiltersServiceFactory)

  function AdvancedFiltersServiceFactory(
    $filter,
    $q,
    $log,
    $translate,
    PromiseService,
    ErrorService,
    DEFAULT_SHOW_LIMIT,
    SELECTED_SUBFILTERS_MAP
  ) {
    'ngInject'

    return {
      generateSelectedConfig: generateSelectedConfig,
      getSubfilterLimitConfig: getSubfilterLimitConfig,
      manageSubfiltersArray: manageSubfiltersArray,
      buildSelectedMessage: buildSelectedMessage,
      selectSubfilter: selectSubfilter,
      loadSubfilters: loadSubfilters,
      buildSubfiltersToBeLoaded: buildSubfiltersToBeLoaded,
      defaultSubfilterSortFn: defaultSubfilterSortFn,
      transformSelectedSubfilters: transformSelectedSubfilters
    }

    function generateSelectedConfig(subfiltersList) {
      return subfiltersList.reduce(function (config, subfilter) {
        config[subfilter] = []
        return config
      }, {})
    }

    function getSubfilterLimitConfig() {
      return {
        showLimit: DEFAULT_SHOW_LIMIT,
        changeVisibleSubfilters: changeVisibleSubfilters,
        resetFilterLimit: resetFilterLimit,
        clearFilterFilter: clearFilterFilter
      }

      function changeVisibleSubfilters(filter) {
        filter.showLimit += DEFAULT_SHOW_LIMIT
      }

      function resetFilterLimit(filter) {
        filter.showLimit = DEFAULT_SHOW_LIMIT
      }

      function clearFilterFilter(filter) {
        filter.search = ''
        filter.showLimit = DEFAULT_SHOW_LIMIT
      }
    }

    function manageSubfiltersArray(subfilterArray, subfilter) {
      if (subfilter.selected) {
        subfilter.checked = true
        subfilter.selected = true
        subfilterArray.push(subfilter.keycode)
      } else {
        for (var i = subfilterArray.length - 1; i >= 0; i--) {
          if (subfilterArray[i] == subfilter.keycode) {
            subfilterArray.splice(i, 1)
          }
        }
      }
    }

    function addNewSubfilters(filter, subFilters, subfilterFilterFn) {
      var i = 0,
        oldSubFilter

      subfilterFilterFn = subfilterFilterFn || defaultSubfilterSortFn

      if (hasDuplicate(subFilters)) {
        filter.subfilterError = true
        filter.subfilters = []
        $log.error('Filter with ID (' + filter.id + ') has duplicate key codes')
        return
      }
      filter.subfilterError = false

      if (filter.subfilters) {
        for (; i < filter.subfilters.length; i++) {
          oldSubFilter = filter.subfilters[i]
          if (oldSubFilter.checked) {
            var newSubFilterItem = subFilters.find(function (subFilter) {
              return subFilter.keycode == oldSubFilter.keycode
            })
            if (!newSubFilterItem) {
              oldSubFilter.count = 0
              oldSubFilter.removed = true
              subFilters.push(oldSubFilter)
            } else {
              newSubFilterItem.checked = true
              newSubFilterItem.selected = true
            }
          }
        }
      }
      subFilters = subfilterFilterFn(subFilters, filter.id)
      filter.subfilters = subFilters
    }

    function hasDuplicate(subFilters) {
      var keyCodes = _.map(subFilters, function (item) {
        return item.keycode
      })

      return _.some(keyCodes, function (keyCode, index) {
        return keyCodes.indexOf(keyCode) != index
      })
    }

    function buildSelectedMessage(array) {
      return array.length > 0
        ? '(' +
            $translate.instant(
              'plural_nSelected_filters',
              { count: array.length },
              'messageformat'
            ) +
            ')'
        : ''
    }

    function selectSubfilter(selectedSubFilters, callbackFn) {
      return function (subfilter, filter, doCallback) {
        //By default, the callbackFn should be executed
        var execute = angular.isDefined(doCallback) ? doCallback : true
        if (angular.isUndefined(subfilter.selected)) {
          subfilter.selected = true
        } else {
          subfilter.selected = !subfilter.selected
        }

        manageSubfiltersArray(selectedSubFilters[filter.id], subfilter)

        if (angular.isFunction(callbackFn) && execute) {
          callbackFn()
        }
      }
    }

    function loadSubfilters(
      filters,
      lastSubfilterSearches,
      searchFilters,
      selectedSubfilters,
      subfilterRequestGetter,
      subfilterCallbackFn,
      subfilterFilterFn
    ) {
      var i = 0,
        promises = [],
        filter

      if (!filters) {
        return
      }

      for (; i < filters.length; i++) {
        filter = filters[i]
        filter.subfiltersLoaded = false
        promises.push(
          requestSubfilters(
            filter,
            filters,
            lastSubfilterSearches,
            searchFilters,
            selectedSubfilters,
            subfilterRequestGetter,
            subfilterCallbackFn,
            subfilterFilterFn
          )
        )
      }

      return $q.all(promises)
    }

    function buildSubfiltersToBeLoaded(filters) {
      /* reloads Subfilters options just for the following cases:
       * options are currently visible (the subfilter view is expanded)
       * options are currently loaded and at least 1 option is checked, it doesn't matter if the view is expanded
       * */

      var filtersToLoad = _.filter(filters, function (f) {
        return (
          f.opened ||
          (f.subfiltersLoaded &&
            angular.isDefined(_.find(f.subfilters, { checked: true })))
        )
      })

      /* marks the remaining Subfilters options (from previous step) as not loaded in order to be reloaded in the next user interaction */
      var diff = _.difference(_.map(filters, 'id'), _.map(filtersToLoad, 'id'))
      var result = _.filter(filters, function (obj) {
        return diff.indexOf(obj.id) >= 0
      })
      _.each(result, function (x) {
        x.subfiltersLoaded = false
      })

      return filtersToLoad || []
    }

    function requestSubfilters(
      filter,
      filters,
      lastSubfilterSearches,
      searchFilters,
      selectedSubfilters,
      subfilterRequestGetter,
      subfilterCallbackFn,
      subfilterFilterFn
    ) {
      if (lastSubfilterSearches[filter.id]) {
        PromiseService.cancelPromise(lastSubfilterSearches[filter.id])
      }

      if (selectedSubfilters) {
        angular.extend(searchFilters, selectedSubfilters)
      }
      lastSubfilterSearches[filter.id] = subfilterRequestGetter(
        filter.id,
        searchFilters
      )

      return lastSubfilterSearches[filter.id].then(function (response) {
        var responseFilters = response.data.filters
        // the attackers filter includes duplicates sometimes. TS-13111 has been created to investigate this
        // if there is a teamserver bug that gets fixed, this can be removed
        if (filter.id === 'attackers') {
          responseFilters = _.uniqBy(responseFilters, 'keycode')
        }
        addNewSubfilters(filter, responseFilters, subfilterFilterFn)
        consolidateSubfilters(subfilterCallbackFn)(
          filters,
          selectedSubfilters,
          filter
        )
        filter.subfiltersLoaded = true
        filter.showLimit = DEFAULT_SHOW_LIMIT
      }, ErrorService.processError)
    }

    function consolidateSubfilters(callbackFn) {
      return function (filters, selectedSubfilters, filter) {
        var i = 0,
          hasOpened = filters.find(function (filter) {
            return filter.opened
          }),
          subFilter

        for (; i < filter.subfilters.length; i++) {
          subFilter = filter.subfilters[i]

          var subFiltersMapValues
          angular.forEach(selectedSubfilters, function (subfilters, name) {
            subFiltersMapValues = SELECTED_SUBFILTERS_MAP[name]
            if (
              angular.isArray(subFiltersMapValues) &&
              subFiltersMapValues.indexOf(filter.id) > -1
            ) {
              var exists = false

              if (angular.isArray(subfilters)) {
                exists = subfilters.indexOf(subFilter.keycode) > -1
              } else if (_.isBoolean(subfilters)) {
                exists = subfilters && name == subFilter.keycode
              }

              if (exists) {
                subFilter.checked = true
                subFilter.selected = true
                if (!hasOpened) {
                  filter.opened = true
                }
              }
            }
          })

          if (angular.isFunction(callbackFn)) {
            callbackFn(filter, subFilter)
          }
        }
      }
    }

    function defaultSubfilterSortFn(subFilters) {
      return $filter('orderBy')(subFilters, 'label')
    }

    function transformSelectedSubfilters(selectedSubFilters, requestMapping) {
      var transformedSubfilters = {}

      angular.forEach(selectedSubFilters, function (value, key) {
        transformedSubfilters[requestMapping[key]] = value
      })

      return transformedSubfilters
    }
  }
})()
